import '../../components/command-select';
import '../../components/json-editor';
import './command-cascade';
import * as testRooms from './test-rooms';
import JsonEditor from '../../components/json-editor';
import Signal from '../../control-flow/signal';
import elt from '../../html/elt';
import injectCSS from '../../html/inject-css';
import logging from '../../logging';
import { CommandCascade } from './command-cascade';
import { camel2words, capitalize } from '../../text/lettercase';

const log = logging('components');

export default class ViewerComponent extends HTMLElement {

    editor: JsonEditor;
    canvas: HTMLCanvasElement;
    btnUndo: HTMLButtonElement;
    btnRedo: HTMLButtonElement;
    cascade: CommandCascade;

    onUndo = new Signal('onUndo', 'components');
    onRedo = new Signal('onRedo', 'components');

    constructor() {
        super();

        this.canvas = elt('canvas', {'class': 'viewer-component-canvas'});
        this.editor = elt('json-editor',
                          {'class': 'viewer-component-json-editor suppress-global-key-listeners'});

        this.cascade = elt('command-cascade',
                           {"class": 'viewer-command-cascade', 'channel': 'viewer'});
        this.cascade.innerHTML = CASCADE_HTML;

        // Note that the injectCSS procedure uses a global cache to avoid
        // doubling these additions, but we also don't need to do this at all
        // if this component is not used on the page.
        injectCSS(STYLESHEET);
    }

    connectedCallback() {
        const availableTestRooms = Object.keys(testRooms).map(
            name => elt('option', {value: name}, capitalize(camel2words(name))));

        this.append(
            this.canvas,
            this.editor,
            elt('div', {'class': 'viewer-component-toolbar'},
                elt('command-select',
                    {'action': 'load', 'channel': 'viewer'},
                    ...availableTestRooms)),
            this.cascade,
        );
    }

    showExitCommand(show: boolean) {
        if(show) {
            this.cascade.firstElementChild.append(
                elt('li', {class: "viewer-exit-command"}, 'exit'));
        } else {
            for(const item of this.querySelectorAll('.viewer-exit-command')) {
                item.remove();
            }
        }
    }

}
window.customElements.define('viewer-component', ViewerComponent);
log.debug('Defined custom element <viewer-component>');

/**
 * This stylesheet is injected into the DOM at construction time, but only once
 * for the life of the page.
 */
const STYLESHEET = `
viewer-component {
    position: fixed;
    top: 0px; left: 0px;
    bottom: 0px; right: 0px;

    z-index: 1000000;

    display: grid;
    overflow: hidden;

    grid-template-columns: 30vw 1fr;
    grid-template-rows: 2em calc(100vh - 4em) 2em;

    grid-template-areas: 
        "json-editor  toolbar"
        "json-editor  viewport-container"
        "json-editor  command-cascade"
        ;

    background-color: white;
}

.viewer-component-toolbar {
    grid-area: toolbar;
    padding: 8px;
}

.viewer-component-json-editor {
    grid-area: json-editor;
    overflow: hidden;
}

.viewer-component-canvas {
    grid-area: viewport-container;
    width: 100%;
    height: 100%;
    background-color: white;

    user-select: none;
}

.viewer-command-cascade {
    grid-area: command-cascade;
    width: 100%;
    height: 2em;
}
`;


const CASCADE_HTML = `
<ul class="active">
    <li title="Return to the JSON prior to the last update">undo</li>
    <li title="Return to the state prior to the last undo">redo</li>
    <li>
        <label>views</label>
        <ul>
            <li title="Update the 3D view from the JSON [Esc]">update</li>
            <li title="Re-generate the 3D view from the current domain model">refresh</li>
            <li title="Force a repaint of the canvas">repaint</li>

            <li title="Download a render.glb file that can be imported into Blender for rendering">render.glb</li>
        </ul>
    </li>

    <li>orbit</li>
    <li>walk</li>
    <li>overhead</li>



</ul>
`;

